import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { CenterCard } from '@/components/CenterCard';

/**
 * EAA-1825: the terminal state of the sign-in loop guard — shown when the portal
 * holds a valid OIDC session but portal-api keeps refusing it, so redirecting to
 * the IdP again would only reload the tab (see `auth/signInLoop.ts`).
 *
 * Deliberately NOT phrased as "your session expired": it has not, and telling the
 * user to sign in again sends them back into the loop we just stopped. The copy
 * names the real shape ("signed in, but the system will not accept the session")
 * and offers the two things that can actually help — one manual retry, or signing
 * out so the next sign-in starts from a clean IdP session.
 */
export function SessionErrorCard({
    onRetry,
    onSignOut,
}: {
    onRetry: () => void;
    onSignOut: () => void;
}) {
    const { t } = useTranslation();
    return (
        <CenterCard title={t('shell.sessionError.title')} showSpinner={false}>
            <p>{t('shell.sessionError.message')}</p>
            <p className="portal-session-error-hint">{t('shell.sessionError.hint')}</p>
            <div className="portal-session-error-actions">
                <Button type="primary" onClick={onRetry}>
                    {t('shell.sessionError.retry')}
                </Button>
                <Button onClick={onSignOut}>{t('shell.sessionError.signOut')}</Button>
            </div>
        </CenterCard>
    );
}
